const SidebarEventDetails = (alertId, definitionId) => ({
  id: "alert-event-details",
  title: "Alert/Event Details",
  componentKey: "replay-search-sidebar",
  props: { alertId, definitionId }
});
export default SidebarEventDetails;
